// extracted by mini-css-extract-plugin
export default {"backgroundOverlay":"BackgroundOverlay_backgroundOverlay__10juW","fadein":"BackgroundOverlay_fadein__pq-nA"};